import { IconButton } from "@mui/material";
import about from "../assets/images/about.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function About() {
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [location]);

  return (
    <div className="about">
      <div className="left-container">
        <h1>ABOUT US</h1>
        <p>
          Kalyanam was born from our own journey in the wedding industry. As vendors with more than 10 years of experience, we’ve seen firsthand how overwhelming it can be to find the right partners for a celebration. When we planned our own wedding, we spent endless hours searching and thought: <i>there must be an easier way.</i>
          <br />
          <br />

          There wasn’t. So we created one.
          <br />
          <br />

          Kalyanam brings all types of vendors together on one platform. We designed Kalyanam to make event planning in the Tamil community effortless, so you can spend more time enjoying the moments that truly matter.
        </p>
        <h2>Jebisan & Harishmi</h2>
      </div>

      <div className="right-container">
        <img className="bg" src={about} alt="" />
      </div>

    </div>
  );
}

export default About;
